module.exports = __webpack_public_path__ + "img/login_bg.43240e6f.png";